import { hasTouchScreen } from '@/utils/DeviceUtility'

export default {
  incompleteTickets: [],
  hasTouchScreen: hasTouchScreen(),
  lastWidgetTap: { widgetId: undefined, x: undefined, y: undefined },
  inventorySummarySelectedLocationId: undefined,
  ticketSummarySelectedDestinationId: undefined
}
